import { Component, EventEmitter, Output } from '@angular/core';


export class SkyHelpInlineComponent {
    
    public actionClick = new EventEmitter<any>();

    public buttonClicked() {
        this.actionClick.emit();
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'sky-help-inline',
    styles: [`.sky-help-inline {
  color: #007ca6;
  font-size: 15px;
  background-color: transparent;
  border: none;
  display: inline-block;
}

.sky-help-inline:hover {
  color: #005673;
  transition: color 150ms;
}
`],
    template: `<button
    class="sky-help-inline fa fa-info-circle"
    (click)="buttonClicked()"
    [attr.aria-label]="'show_help_content' | skyResources"
    >
</button>`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'actionClick': [{ type: Output },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
